import {
  AfterViewInit,
  Component,
  DoCheck,
  ElementRef,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  ApiService,
  EventEmitterService,
  MatDialogUtilsService,
  UtilsService,
} from "src/app/shared/services";
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from "@angular/cdk/layout";
import { Observable, Subscription } from "rxjs";
import { EnvService } from "../../../shared/services/env.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Options } from "ng5-slider";
import {
  IFilterData,
  IProductPayload,
  IProductsPayload,
} from "src/app/shared/models";
import { HttpParams } from "@angular/common/http";
import { Location } from "@angular/common";
import { isArray } from "util";
import { delay, first } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SCROLL_ICON_SHOW_DURATION } from "src/app/shared/constants";
import { MatDialog } from "@angular/material/dialog";
import { NgxMasonryComponent } from "ngx-masonry";
import { ImageSearchDialogComponent } from "src/app/shared/components/image-search-dialog/image-search-dialog.component";

@Component({
  selector: 'app-product-catalog',
  templateUrl: './product-catalog.component.html',
  styleUrls: ['./product-catalog.component.less']
})
export class ProductCatalogComponent implements OnInit, DoCheck, AfterViewInit {
  interval: ReturnType<typeof setInterval> | undefined;
  isFetched = false;
  isUpdating = false;
  spinner = "assets/image/spinner.gif";
  dummyProductListings: any[] = [
    {
      displayable: true,
      main_image: '',
      height: '300px'
    },
    {
      displayable: true,
      main_image: '',
      height: '350px'

    },
    {
      displayable: true,
      main_image: '',
      height: '200px'

    },
    {
      displayable: true,
      main_image: '',
      height: '250px'
    }, {
      displayable: true,
      main_image: '',
      height: '300px'
    },
    {
      displayable: true,
      main_image: '',
      height: '400px'

    },
    {
      displayable: true,
      main_image: '',
      height: '200px'

    },
    {
      displayable: true,
      main_image: '',
      height: '280px'
    },
  ];
  productListings: any[] = [];
  query: string;

  page: number = 0;
  sorting: { sortBy: string; direction: any } = {
    sortBy: "",
    direction: "",
  };
  sortBy: string = "";
  sortType: string = "newest_first";
  currentResponseLength: number = 0;

  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  bpSubscription: Subscription;
  isHandset = false;

  showBottomPanel = true;
  item: any;
  department_long: any;
  keyword: string;
  products: IProductPayload[];
  trend: string;
  category: string;
  totalCount = 0;
  isProductFetching: boolean;
  total = 24;
  sortTypeList: any[] = [
    {
      "name": "Top Picks",
      "value": "recommended",
      "enabled": false
    },
    {
      "name": "Price: Low to High",
      "value": "price_low_to_high",
      "enabled": false
    },
    {
      "name": "Price: High to Low",
      "value": "price_high_to_low",
      "enabled": false
    },
    {
      "name": "Newest First",
      "value": "newest_first",
      "enabled": false
    }
  ];
  pageNo: number;

  productsSubscription: Subscription;
  productsInRow: number = 2;

  routeSubscription: Subscription;
  showLoader: boolean;

  projectOptions: any[] = [];
  selectedDropdown = '';
  selectedProject = '';
  selectedDetails: any;
  innerWidth: number;
  assetBaseUrl: string;
  productsLoading: boolean;
  public Math: Math = Math;
  throttle = 700;
  scrollDistance = 1;
  scrollUpDistance = 2;
  gridView = true;
  allItems = true;

  @ViewChild('mySidenav') mySidenav: ElementRef;

  noProducts: boolean;

  private originalOffsetTop!: number;
  private isFixed = true;

  pageWidth: number;
  totalProducts: number;
  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;
  wishlistProducts: any[] = [];
  urlProduct: any;
  urlVariant: any;
  productListingSubscription: Subscription;
  filterProductListSubscription: Subscription;
  reachedLastPage: boolean;
  errorMsg: any;
  partnersList: any[] = [
    {
      "name": "Gold",
      "value": "Gold"
    },
    {
      "name": "Silver",
      "value": "Silver"
    },
    {
      "name": "Bronze+",
      "value": "Bronze+"
    },
    {
      "name": "Bronze",
      "value": "Bronze"
    }
  ];
  partners = [];
  callSearchProducts: Subscription;
  width: number;
  height: number
  filterQuery: string = '';
  slideIndex = 1;
  imgSearch: boolean;
  imgSearchUrl: string = '';
  productDetails: any;
  topPosToStartShowing = 300;
  fixFilterBar = 150;
  isIconShow = false;
  showBar = false;
  timeout: any;
  productInfo: any;
  isVariationCallLoading: boolean;
  isVariationExist: boolean;
  variations: any;
  hasSelection: any;
  newVariationFound: boolean;
  paramSku: string;
  loadDetails = false;

  constructor(
    public api: ApiService,
    private breakpointObserver: BreakpointObserver,
    public env: EnvService,
    private router: Router,
    private location: Location,
    public utils: UtilsService,
    private activeRoute: ActivatedRoute,
    private eventEmitterService: EventEmitterService,
    private matDiaService: MatDialogUtilsService,
    private matSnackbar: MatSnackBar,
    private dialog: MatDialog
  ) {
    this.assetBaseUrl = this.env.assetSLBaseUrl;
    document.addEventListener("click", this.findTopmostParent.bind(this));
    this.productListings = this.dummyProductListings;
    this.keyword = "all";
    this.bpSubscription = this.bpObserver.subscribe(
      (handset: BreakpointState) => {
        this.isHandset = handset.matches;
      }
    );
    this.pageWidth = document.body.clientWidth;
    this.getWishList();

  }

  getParamsFromQuery(): void {
    this.activeRoute.queryParams.subscribe(
      (params) => {
        this.filterQuery = JSON.parse(JSON.stringify(params.filters || ''));
        this.urlProduct = params.product;
        this.urlVariant = params.variant;
        if (this.urlProduct) {
          setTimeout(() => {
            this.getProductData(this.urlProduct)
          }, 1000);
        }
        this.query = params.query || "";
        // this.pageNo = params.pageNo ||1;

        // this.getFilteredEle(params.filters);
        this.pageNo = (parseInt(params.pageNo) - 1) || 0;
        this.sortType = params.sortType || "";
        this.sorting.direction = this.sortType;
        this.sorting.sortBy = this.sortType === 'price_high_to_low' ? 'desc' : 'asc';
        if(params.image_url) {
  this.imgSearchUrl = params.image_url ? params.image_url : '';

          this.api.imgSearchData = {
            image_url: params.image_url,image_upload: null, 
            partner_tier: params.partner_tier || 'Gold,Silver,Bronze+,Bronze,NA'
          }
        }

        // this.getFiltersFromQuery();
        // this.api.isSideNavOpened = true;
        if (this.query || params.image_url) {
          this.page = (parseInt(params.pageNo) - 1) || 0;
          if (this.pageNo === 0 || this.pageNo === -1) { this.productListings = this.dummyProductListings; }
          this.search();
        } else {
          // this.updateQueryString();
          this.getProductListing(this.pageNo);
          setTimeout(() => {
            if (this.masonry !== undefined) {
              this.masonry.reloadItems();
              this.masonry.layout();
            }
          }, 1000);
        }

      }
    );
  }

  clearImgSearch() {
    this.imgSearchUrl = '';
    this.api.imgSearchData = null;
    this.productListings = this.dummyProductListings;
    this.pageNo = 0;
    this.getProductListing();
  }
 
  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.assetBaseUrl = this.env.assetSLBaseUrl;
    this.sorting.sortBy = 'asc';
    this.sorting.direction = 'newest_first';
    this.sortType = 'newest_first';
    this.getParamsFromQuery();

    // this.eventEmitterService.userChangeEvent
    //   .asObservable()
    //   .subscribe((user) => {
    //     if (user.id && user.email) {
    //     } else {
    //     }
    //   });

    this.getDesignprojectDropdown();
  } 

  getWishList() {
    this.api.getWishlistProducts(false).subscribe((payload: IProductsPayload) => {
      if (payload?.products?.length > 0) {
        this.wishlistProducts = payload.products;
      }
    }, err => {
    });
  }

  removeFav(sku) {
    const ind = this.productListings.findIndex(f => f.sku === sku);
    if (ind > -1) {
      this.productListings.splice(ind, 1);
      this.totalProducts--;
      setTimeout(() => {
        if (this.masonry !== undefined) {
          this.masonry.reloadItems();
          this.masonry.layout();
        }
      }, 0);
    }
  }

  ngAfterViewInit() {
    this.hideIntercomIcon()

    const filterBar = document.getElementById('filterBar');
    if (filterBar) {
      this.originalOffsetTop = filterBar.offsetTop;
      this.onWindowScroll()
    }
  }


  @HostListener('window:scroll', [])
  onWindowScroll() {
    const filterBar = document.getElementById('filterBar');
    if (!filterBar) return;

    const scrollPosition = window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    if (scrollPosition >= this.originalOffsetTop && !this.isFixed) {
      filterBar.style.position = 'fixed';
      filterBar.style.top = '0';
      filterBar.style.width = this.api.isAdminSidePanelOpened ? (this.pageWidth - 200) + 'px' : this.pageWidth + 50 + 'px';
      filterBar.style.background = '#fff';
      filterBar.style.zIndex = '1';
      filterBar.style.marginTop = '0px';

      filterBar.style.padding = '12px 0px';
      this.isFixed = true;
      filterBar.style.marginLeft = '0px';

    } else if (scrollPosition < this.originalOffsetTop && this.isFixed) {
      filterBar.style.position = 'static';
      filterBar.style.marginTop = this.query ? '10px' : '0px';
      filterBar.style.marginLeft = '-20px';


      this.isFixed = false;
    }

    this.isIconShow = scrollPosition >= this.topPosToStartShowing;
    this.showBar = scrollPosition >= this.fixFilterBar;
    const self = this;
    if (this.isIconShow) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        self.isIconShow = false;
      }, SCROLL_ICON_SHOW_DURATION);
    }
  }

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  findTopmostParent(element) {
    let parent = element.target.parentNode;
    let isOk; 
    console.log(parent.className,'classname',element.target.innerHTML)
    let firstNode = element.target.innerHTML.includes('SHOW') ||
    parent.outerHTML.includes('display: flex;flex-wrap: wrap;gap: 16px') 
   || (element.target.innerHTML.includes('(') && element.target.innerHTML.includes(')'))
      || (parent && (parent.className?.includes("filter-sectionCheck") || parent.textContent === ('Select All')
        || parent.textContent.includes('SHOW')
        || parent.textContent.includes('Clear All') || parent.className?.includes("mat-option") || parent.className?.includes("mat-select")
        || parent.className?.includes('mat-button-wrapper' )
     || parent.className?.includes('cdk-overlay-container') )
      ) ? true : false;
    while (parent && parent.parentNode) {
      if (parent.id === "mySidenav") {
        isOk = true;
        break;
      }
      parent = parent.parentNode;
    }
    console.log(firstNode,'firstNode')

    if (!isOk && !firstNode) {
      this.closeNav();
    }
  }
  @HostListener("window:resize")
  onResize() {
    this.height = window.innerHeight;
    this.width = window.innerWidth;
    this.pageWidth = document.body.clientWidth;

  }
  panelStateChange() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  getValue(key) {
    return key.replace(/[_-]/g, ' ').toUpperCase();
  }

  changeLayout() {
    if (this.gridView) {
      this.gridView = false
      this.goTableView();
    } else {
      this.gridView = true;
    }
  }

  getDesignprojectDropdown() {
    this.api.getProjectDropdown().subscribe((res: any) => {
      this.projectOptions = res;
      this.projectOptions.forEach(f => {
        f['displayName'] = this.utils.formatRoomLabel(f);
      })
    });
  }

  ngDoCheck(): void {

    if (this.matDiaService.closeClicked) {
      this.matDiaService.closeClicked = false;
    }
  }

 async getProductListing(page = 0) {
    this.isUpdating = true;
    this.noProducts = false;
    this.reachedLastPage = false;

    this.productListingSubscription = this.api
      .getAllProductsListing(
        page,
        this.filterQuery,
        this.sorting.sortBy,
        this.sorting.direction
      )
      .subscribe(
      async  (response: any) => {
          if (response.status === "Unauthorised") {
            this.isFetched = true;
            this.isUpdating = false;
            const width = this.isHandset ? "90%" : "35%";
            const data = this.matDiaService.openSigninDialog(width, true);
            data.afterClosed((res) => {
            });
            this.productsLoading = false;

          } else if (response.products.length === 0) {
            this.isFetched = true;
            this.isUpdating = false;
            if (response.total === 0) {
              this.noProducts = true;
              this.totalProducts = -1;

              this.errorMsg = response.error || 'No Products found! Please try to remove filters or contact support for further assistance.';

            }


          } else {
            this.totalProducts = response.total;

             const validatedProducts = await this.processProducts(response);


       
            this.isFetched = true;



            this.productsLoading = false;
            this.productListings = this.productListings.filter(f => !f.height);
            // if (page === 0) {
              // this.productListings = [];
            //   this.productListings = [...this.productListings, ...validatedProducts];
            // } 
            // }
            this.productListings = [...this.productListings, ...validatedProducts];
            this.isFetched = true;
            this.isUpdating = false;
            this.currentResponseLength = validatedProducts.length;
            this.updateQueryString();
            this.reachedLastPage = this.productListings.length === response.total;

            setTimeout(() => {
              for (let i = 0; i < this.productListings.length; i++) {
                this.showSlides(0, i, true);
              }

            }, 0);

          }

        },
        (err) => {
          this.productsLoading = false;
          this.matSnackbar.open('Api error', 'x', { duration: 7000 })
          if (err.error.status === "Unauthorised") {
            this.isFetched = true;
            this.isUpdating = false;
            const width = this.isHandset ? "90%" : "35%";
            const data = this.matDiaService.openSigninDialog(width, true);
            data.afterClosed((res) => {
            });
            this.closeNav();
          }
        }
      );
  }


  async processProducts(response: any) { 
    const products = response.products.map((product: any) => {
      // Start with base object
      const processed: any = {
        ...product,
        loaded: false,
        padding: '14px',
        allImages: [],
        isMainImageAccessible: false,
        checked: false,// temporary
        product_feature: this.utils.compileMarkdown(product.feature)
      };

      if (this.wishlistProducts.find(f => f.sku === product.product_sku)) {
        product["wishlisted"] = true;
      } else {
        product["wishlisted"] = false;

      }

      // Collect all images
      if (product.main_product_images) {
        processed.allImages.push(...product.main_product_images.split(','));
      }
      if (product.product_images_gallery) {
        processed.allImages.push(...product.product_images_gallery.split(','));
      }

      // Flatten & assign main image
      processed.allImages = processed.allImages.flat();
      if (processed.allImages.length > 0) {
        processed.main_image = this.assetBaseUrl + processed.allImages[0];
        processed.mainImage = processed.main_image;
      }
      processed.condition = product.product_condition;
      // Map additional fields
      processed.name = product.product_name;

      // Handle discount
      processed.percent_discount =
        product.percent_discount &&
          product.percent_discount !== '0.00' &&
          +product.percent_discount > 0 &&
          product.percent_discount !== '0'
          ? parseInt(product.percent_discount, 10)
          : '';

      return processed;
    });

    const validatedProducts = await Promise.all(
      products.map(async (p) => {
        if (p.mainImage) {
          p.isMainImageAccessible = await this.api.checkImageAccessible(
            p.mainImage
          );
        }
        return p;
      })
    );

    return validatedProducts;
  }

  loadMore() {
    if (this.isUpdating) return; 
    this.page++;
    this.isFetched = false;
    this.reachedLastPage = false;
    this.getProductListing(this.page);
  }

  setSorting(newSortBy: string) {
    if (this.sorting.sortBy === newSortBy) {
      this.sorting.direction =
        this.sorting.direction === "asc" ? "desc" : "asc";
    } else {
      this.sorting.sortBy = newSortBy;
      this.sorting.direction = "asc";
    }
    this.productListings = this.dummyProductListings;
    this.getProductListing();
  }

  toggleSort(newSortType: string) {
    this.sortType = newSortType;
    this.productListings = this.dummyProductListings;
    this.getProductListing();
  }

  openImageInNewTab(imageUrl: string) {
    window.open(imageUrl, "_blank");
  }

  openProductInNewTab(productUrl: string) {
    this.router.navigate([]).then(() => {
      window.open(`product/${productUrl}`, "_blank");
    });
  }

  plusSlides(event, n: number, row) {
    event.stopPropagation();

    this.showSlides((this.slideIndex += n), row);
  }

  showSlides(n, row, init?) {
    let i;
    let slides = document.getElementsByClassName(
      "mySlides" + row
    ) as HTMLCollectionOf<HTMLElement>;
    if (!init) {
      if (n > slides.length) {
        this.slideIndex = 1;
      }
      if (n < 1) {
        this.slideIndex = slides.length;
      }
    } else {
      this.slideIndex = 1;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    if (slides[this.slideIndex - 1]) {
      slides[this.slideIndex - 1].style.display = "block";
    }
  }

  loadProducts(): void {
    this.pageNo = 0;
    this.isProductFetching = true;
    this.getProductListing();
  }

  updateQueryString(): void {
    const params: string[] = [];

    if (this.selectedProject) {
      params.push(`room_id=${encodeURIComponent(this.selectedProject)}`);
    }
    if (this.filterQuery) {
      params.push(`filters=${encodeURI(this.filterQuery)}`);
    }
    if (this.sortType) {
      params.push(`sortType=${encodeURIComponent(this.sortType)}`);
    }
    if (this.urlProduct) {
      params.push(`product=${encodeURIComponent(this.urlProduct)}`);
    }
    if (this.urlVariant) {
      params.push(`variant=${encodeURIComponent(this.urlVariant)}`);
    }
    if (this.query) {
      params.push(`query=${encodeURIComponent(this.query)}`);
    }
    if(this.api.imgSearchData && this.api.imgSearchData.image_url) {
      params.push(`image_url=${encodeURIComponent(this.api.imgSearchData.image_url)}`);
    }

    // Append pageNo LAST
    if (this.pageNo) {
      params.push(`pageNo=${encodeURIComponent(this.pageNo.toString())}`);
    } else if (this.page) {
      params.push(`pageNo=${encodeURIComponent(this.page.toString())}`);
    }

    this.location.replaceState(
      window.location.pathname,
      params.join("&"),
      this.location.getState()
    );
  }


  onSetSortType(e): void {
    if (this.allItems) {
      this.sortType = e;
      this.sorting.sortBy = e === 'price_high_to_low' ? 'desc' : 'asc';
      this.sorting.direction = e;
      this.pageNo=0;
      this.page=0;
         this.productListings = this.dummyProductListings;

      this.loadProducts();
      setTimeout(() => {
        if (this.masonry !== undefined) {
          this.masonry.reloadItems();
          this.masonry.layout();
        }
      }, 1000);
    }
  }

  hideIntercomIcon() {
    const interval = setInterval(() => {
      const intercom = document.getElementsByClassName(
        "intercom-lightweight-app"
      )[0];
      if (intercom) {
        intercom.classList.add("dn");
        clearInterval(interval);
      }
    }, 500);
    const intervalx = setInterval(() => {
      const intercomx = document.getElementsByClassName("intercom-app")[0];
      if (intercomx) {
        intercomx.classList.add("dn");
        clearInterval(intervalx);
      }
    }, 500);
  }

  showIntercom() {
    const intercom = document.getElementsByClassName(
      "intercom-lightweight-app"
    )[0];
    if (intercom && intercom.classList) {
      intercom.classList.remove("dn");
    }
  }

  goTableView() {
    this.gridView = false
    setTimeout(() => {
      for (let i = 0; i < this.productListings.length; i++) {
        this.showSlides(0, i, true);
      }
    }, 0);
  }

  openNav() {
    document.getElementById("mySidenav").style.width = "650px";
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    this.api.isSideNavOpened = true;
  }

  closeNav() {
    if (document.getElementById("mySidenav")) {
      document.getElementById("mySidenav").style.width = "0";
      document.body.style.backgroundColor = "white";
      this.api.isSideNavOpened = false;
    }
  }

  get getChecks() {
    return this.productListings.filter((f) => f.checked).length > 0;
  }

  getProductData(event) {
    this.closeProductNav('');
    this.productDetails = event;
    this.paramSku = typeof event === 'string' ? event : event.product_sku ? event.product_sku : event.sku;
    this.loadDetails = true;
    this.openProductNav();
  }

  openProductNav() {
    document.getElementById("productSidenav").style.width = "450px";
    document.getElementById('productSidenav').scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    this.api.isSideNavOpened = true;
  }

  closeProductNav(msg) {
    if (document.getElementById("productSidenav")) {
      this.loadDetails = false;
      document.getElementById("productSidenav").style.width = "0";
      document.body.style.backgroundColor = "white";
      if (msg !== 'close' && msg) {
        this.matSnackbar.open(msg, 'x', { duration: 3000 })
      }
      this.api.isSideNavOpened = false;

    }
  }
  updateParamOnClose(){ 
      this.urlProduct = null;
      this.urlVariant = null; 
      this.updateQueryString();
  }

  onAllScrollDown() {
    if (!this.query && !this.api.imgSearchData) {
      if (this.allItems) {
        if (!this.isFetched || this.reachedLastPage) return;

        if (this.currentResponseLength === 20)
          this.productListings.push(...this.dummyProductListings)
        this.loadMore();
      }
    } else {
      if (!this.isFetched || this.reachedLastPage) return;
      this.productListings.push(...this.dummyProductListings);
      this.search();
    }
  }

  clearPartners() {
    this.partners = [];
    this.searchNewProduct();
  }
  
  partnersChanged() {
    this.searchNewProduct();
  }

  searchNewProduct() {
    this.pageNo = 0;
    if (this.callSearchProducts) {
      this.callSearchProducts.unsubscribe();
    }
    if (this.pageNo === 0 || this.pageNo === -1) { this.productListings = this.dummyProductListings; }
    setTimeout(() => {
      if (this.masonry !== undefined) {
        this.masonry.reloadItems();
        this.masonry.layout();
        this.search();

      }
    }, 500);

  }

  search() {
    this.totalProducts = -1;
    this.isFetched = false;
    this.reachedLastPage = false;
    this.errorMsg = '';
    let call: any;
    this.pageNo = this.pageNo + 1;
    if (this.api.imgSearchData) {
      this.api.imgSearchData['partner_tier'] = this.partners.length === 0 ? 'Gold,Silver,Bronze+,Bronze,NA' : this.partners.join(',');
      call = this.api.searchProducts('', this.pageNo, this.api.imgSearchData)
    } else {
      let imgData = {
        partner_tier: this.partners.length === 0 ? 'Gold,Silver,Bronze+,Bronze,NA' : this.partners.join(',')
      }

      call = this.api
        .searchProducts(this.query, this.pageNo, imgData)
    }

    this.callSearchProducts = call.subscribe(
      (response: any) => {
        const items = response.page_size * response.total_pages;
        this.totalProducts = items;
        if (response.status === "Unauthorised") {
          this.isFetched = true;
          this.isUpdating = false;
          const width = this.isHandset ? "90%" : "35%";
          const data = this.matDiaService.openSigninDialog(width, true);
          data.afterClosed((res) => {
          });
          this.productsLoading = false;
        } else if (response.results?.length === 0 || response.error) {
          this.isFetched = true;
          this.isUpdating = false;
          if (items === 0 || response.error) {
            this.noProducts = true;
            this.errorMsg = response.error || 'No Products found! Please try to remove filters or contact support for further assistance.';
          }

        } else {
          response.results.forEach((product: any) => {
            if (this.wishlistProducts.find(f => f.sku === product.product_sku)) {
              product["wishlisted"] = true;
            } else {
              product["wishlisted"] = false;

            }
            product['isMainImageAccessible'] = true;
            product["checked"] = false;
            product["allImages"] = [];
            if (product["main_product_images"]) {
              product["allImages"].push(
                product["main_product_images"].split(",")
              );
            }
            if (product["product_images_gallery"]) {
              product["allImages"].push(
                product["product_images_gallery"].split(",")
              );
            }
            product["allImages"] = product["allImages"].flat();
            product["product_feature"] = this.utils.compileMarkdown(
              product.feature
            );

            product['main_image'] =
              product.allImages[0] ? (this.assetBaseUrl + product.allImages[0]) : 'test';

            //  product['main_image'] = this.assetBaseUrl + product.allImages[0];
            product['name'] = product.product_name;
          });
          this.productsLoading = false;
          this.productListings = this.productListings.filter(f => !f.height);
          if (this.pageNo === 1) {
            this.productListings = [];
            this.productListings = response.results;
            // this.productListings = [...this.productListings, ...response.results];
          } else {
            this.productListings = [...this.productListings, ...response.results];
          }
          this.isFetched = true;

          this.isUpdating = false;
          this.currentResponseLength = response.results.length;
          this.reachedLastPage = (this.pageNo) === response.total_pages;
 

          this.updateQueryString();
          // this.closeNav();
          setTimeout(() => {
            for (let i = 0; i < this.productListings.length; i++) {
              this.showSlides(0, i, true);
            }
          }, 0);
          //  setTimeout(() => {
          //       if (this.masonry !== undefined) {
          //         this.masonry.reloadItems();
          //         this.masonry.layout();
          //       }

          //     }, 500);
        }



      },
      (err) => {
        this.productsLoading = false;
        this.matSnackbar.open('Api error', 'x', { duration: 7000 });
        this.isFetched = true;
        this.isUpdating = false;
        this.noProducts = true;
        this.errorMsg = 'No Products found! Please try to remove filters or contact support for further assistance.';

        if (err.error.status === "Unauthorised") {

          const width = this.isHandset ? "90%" : "35%";
          const data = this.matDiaService.openSigninDialog(width, true);
          data.afterClosed((res) => {
          });
          this.closeNav();
        }
      }
    );

  }

  resetQuery() {
    this.query = '';
    this.totalProducts = -1;
    this.pageNo = 0;
    this.page = 0;
    this.imgSearchUrl = '';
    this.api.imgSearchData = null;
    this.productListings = [];
    this.productListings.push(...this.dummyProductListings);
    setTimeout(() => {

      if (this.masonry !== undefined) {
        this.masonry.reloadItems();
        this.masonry.layout();


      }
      this.getProductListing(0);
    }, 500);

  }

  openImageDialog() {
    this.dialog.open(ImageSearchDialogComponent, {
      width: '700px',
      panelClass: 'image-search-dialog',
      data: {
        page: 'catalog'
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        this.imgSearch = true;
        if (res.image_url) {
          this.imgSearchUrl = res.image_url
        } else {
          this.imgSearchUrl = res.img_preview;
        }
    this.searchNewProduct();
        
      }
    })
  }

  onImageSearch(event) {
console.log(event,'image search event')
this.imgSearch = true;
if (event.image_url) {
  this.imgSearchUrl = event.image_url
} 
else {
  this.imgSearchUrl = event.img_preview;
}
    this.searchNewProduct();
  }
  getTierColor(tier: string): string {
    switch (tier) {
      case 'Gold':
        return '#FFD704';
      case 'Silver':
        return '#D6D6D6';
      case 'Bronze+':
        return '#CD7F31';
      case 'Bronze':
        return '#8C6239';
      default:
        return '#ccc'; // fallback
    }
  }


  reloadProducts(event) {
    if (this.productListingSubscription) {
      this.productListingSubscription.unsubscribe();
    }
    this.filterQuery = event;
    this.pageNo = 0;
    this.page = 0;
    this.productListings = this.dummyProductListings;
    this.updateQueryString();
    this.getProductListing(0);
  }
}